import type { ISwSettings } from "app/@types/ISwSettings";
import { PackageName } from "app/common/constants/packageNames";
import {
    isPackageType,
    isTrialOrAfterTrial,
    isPendingTrialStatus,
} from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const AEO_CAMPAIGN_TYPES = ["ciMonthlyToAnnual", "ciAnnualToAeo", "aeoMonthlyToAnnual"] as const;
export type AeoCampaignType = (typeof AEO_CAMPAIGN_TYPES)[number];

export const AEO_CAMPAIGN_ELIGIBLE_PACKAGES: PackageName[] = [
    PackageName.StarterMonthly,
    PackageName.StarterAnnual,
    PackageName.ProfessionalMonthly,
    PackageName.CompetitiveIntelligenceAnnual,
    PackageName.CompetitiveIntelligenceMonthly,
    PackageName.CompetitiveIntelligenceSeoMonthly,
    PackageName.CompetitiveIntelligenceSeoAeoMonthly,
];

export const isAeoCampaignEligible = (swSettings: ISwSettings): boolean =>
    !isTrialOrAfterTrial(swSettings) &&
    !isPendingTrialStatus(swSettings) &&
    isPackageType(swSettings, AEO_CAMPAIGN_ELIGIBLE_PACKAGES);

export const getAeoCampaignType = (userPlan: PackageName): AeoCampaignType => {
    switch (userPlan) {
        case PackageName.StarterMonthly:
        case PackageName.CompetitiveIntelligenceMonthly:
            return "ciMonthlyToAnnual";
        case PackageName.StarterAnnual:
        case PackageName.CompetitiveIntelligenceAnnual:
            return "ciAnnualToAeo";
        case PackageName.ProfessionalMonthly:
        case PackageName.CompetitiveIntelligenceSeoMonthly:
        case PackageName.CompetitiveIntelligenceSeoAeoMonthly:
            return "aeoMonthlyToAnnual";
    }
    return "ciAnnualToAeo";
};
